import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Loader } from '../../common'
import InformationTable from '../../containers/InformationTable'
import EditInformationItemModal from '../../containers/EditInformationItemModal'
import NewInformationItemModal from '../../containers/NewInformationItemModal'

import * as dataActions from '../../actions/Data'

class InfoSettings extends React.Component {
  componentDidMount() {
    const { data } = this.props

    this.fetch()
  }

  fetch() {
    const { user, data } = this.props

    if (!data.informationItemsFetched) {
      this.props.tryGetInformationItems(user.token, data.community.id)
    }
  }

  render() {
    const { classes, data } = this.props

    if (!data.informationItemsFetched) {
      return (
        <main className={classes.content}>
          <Loader />
        </main>
      )
    }

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <InformationTable />
        <EditInformationItemModal />
        <NewInformationItemModal />
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

InfoSettings.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...dataActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(InfoSettings)



// WEBPACK FOOTER //
// ./src/components/pages/InfoSettings/index.js